import Range from "./DeliveryRange";

export default class DeliveryRegion {
  ranges = [];

  constructor(ranges) {
    ranges.map((p) => {
      return this.ranges.push(
        new Range(
          p.upTo,
          p.price,
          p.minOrder,
          p.freeFee,
          p.old_price,
          p.minDelivery,
          p.maxDelivery
        )
      );
    });
  }

  static getTemplateRange(upTo = 0) {
    return new Range(upTo, 0, 0);
  }
}
